import React from 'react';

import { FirstLetterCapital, StylesButton } from './Button.styles';
import { ButtonProps } from './types';

const Button: React.FC<ButtonProps> = ({
  startIcon,
  endIcon,
  fullWidth,
  text,
  handleClick,
  color,
  type = 'button',
  buttonMargin,
  iconItem,
  disabled,
  colorIcon,
  paddingRight,
  style,
}) => {
  return (
    <StylesButton
      buttonMargin={buttonMargin}
      colorIcon={colorIcon}
      colorVariant={color}
      disabled={disabled}
      fullWidth={fullWidth}
      onClick={handleClick}
      style={style}
      type={type}
    >
      {iconItem}
      <FirstLetterCapital paddingRight={paddingRight}>
        {text}
      </FirstLetterCapital>
      {endIcon}
    </StylesButton>
  );
};

export default Button;
